import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { AlertComponent } from '../../../../../components';
import { getUserByCognitoId } from '../../../../../core/users/action';

const LinkButton = styled(Button)`
  text-transform: none;
  padding: 0;
  min-width: 0;
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
`;

function RetailProfileAlert({ isApproved }) {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.users);

  const onReload = () => {
    dispatch(getUserByCognitoId(user.cognito_id));
  };

  return (
    <AlertComponent
      title="Create Retail Profile"
      content={
        <>
          <p>To create retail profiles:</p>
          <ul>
            {!isApproved && (
              <li>
                Make sure your venue registration is approved.{' '}
                <LinkButton onClick={onReload}>Reload</LinkButton> to check for updates
              </li>
            )}
          </ul>
        </>
      }
      severity="warning"
    />
  );
}

RetailProfileAlert.propTypes = {
  isApproved: PropTypes.bool.isRequired,
};

export default RetailProfileAlert;
